import ServerSettings, {ServerSettingsFieldType} from "../../../gd/settings/server-settings/server-settings"

const fieldsConfig = {
    templateId: {
        type            : ServerSettingsFieldType.VALUE,
    },

    columns: {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : _.map(['2','22','6','5','26'], id=>({id: id})),
    },

    systemStatusFilter: {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : 'open',
        options         : ['open', 'archived', 'all']
    },

    sortBy: {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : null,
    },

    filters: {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : {},
    },

    areEmptyFoldersHidden: {
        type            : ServerSettingsFieldType.BOOLEAN,
        defaultValue    : false,
    },
}

export default class UserSettingsViewsArchivedProjectsView extends ServerSettings {

    public templateId               : any
    public columns                  : any[]
    public systemStatusFilter       : 'open' | 'closed' | 'all'
    public sortBy                   : null // current sort by column value
    public filters                  : {}
    public areEmptyFoldersHidden    : boolean

    constructor(config: any) {

        super(config, fieldsConfig)

        this.templateId             = this.initValue('templateId')
        this.columns                = this.initValue('columns')
        this.systemStatusFilter     = this.initValue('systemStatusFilter')
        this.sortBy                 = this.initValue('sortBy')
        this.filters                = this.initValue('filters')
        this.areEmptyFoldersHidden  = this.initValue('areEmptyFoldersHidden')
    }

    toJson() {
        const result = {}

        this.valueToJson(result, 'templateId')
        this.valueToJson(result, 'columns')
        this.valueToJson(result, 'systemStatusFilter')
        this.valueToJson(result, 'sortBy')
        this.valueToJson(result, 'filters')
        this.valueToJson(result, 'areEmptyFoldersHidden')

        return result
    }
}
